import { SVGProps } from 'react';

export const TrendDown = ({ width = 8, height = 7, fill = '#9d1111' }: SVGProps<SVGElement>): JSX.Element => (
  <svg width={width} height={height} viewBox="0 0 8 7" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6.12134L7.56063 0.560704H0.439366L4 6.12134Z" fill={fill} />
  </svg>
);
